var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _g2, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6576 17.3906L14.9319 32.3323C15.0249 33.4823 15.9779 34.3448 17.1422 34.3448H17.1507H40.2072H40.2115C41.3124 34.3448 42.2528 33.5364 42.4091 32.4635L44.4166 18.7989C44.4631 18.4739 44.3807 18.1489 44.18 17.8864C43.9813 17.6218 43.6897 17.451 43.3601 17.4052C42.9184 17.4218 24.5911 17.3968 13.6576 17.3906ZM17.138 37.4698C14.355 37.4698 11.9988 35.3281 11.7727 32.5885L9.83707 9.89268L6.65256 9.35101C5.78828 9.20101 5.21139 8.39476 5.35931 7.54268C5.51146 6.6906 6.34615 6.13643 7.19141 6.26976L11.5868 7.01976C12.2947 7.14268 12.8335 7.72185 12.8948 8.43018L13.3914 14.2656C43.5587 14.2781 43.6559 14.2927 43.8017 14.3093C44.9787 14.4781 46.0142 15.0843 46.72 16.0177C47.4258 16.9489 47.7216 18.0968 47.5525 19.2468L45.5472 32.9093C45.1689 35.5093 42.8783 37.4698 40.2157 37.4698H40.2051H17.1549H17.138Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8175 25.0913H30.9599C30.0829 25.0913 29.375 24.3913 29.375 23.5288C29.375 22.6663 30.0829 21.9663 30.9599 21.9663H36.8175C37.6924 21.9663 38.4024 22.6663 38.4024 23.5288C38.4024 24.3913 37.6924 25.0913 36.8175 25.0913Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2289 43.1289C16.865 43.1289 17.3785 43.6352 17.3785 44.2622C17.3785 44.8893 16.865 45.3977 16.2289 45.3977C15.5908 45.3977 15.0773 44.8893 15.0773 44.2622C15.0773 43.6352 15.5908 43.1289 16.2289 43.1289Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_823_54324",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 43,
    width: 3,
    height: 3
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0762 44.2618C15.0762 44.8909 15.5897 45.3993 16.23 45.3993C16.866 45.3993 17.3795 44.8909 17.3795 44.2618C17.3795 43.6347 16.866 43.1284 16.23 43.1284C15.5897 43.1284 15.0762 43.6347 15.0762 44.2618Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_823_54324)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.51257 55.814H27.9453V32.7119H4.51257V55.814Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2268 43.8352C15.9881 43.8352 15.7937 44.0268 15.7937 44.2622C15.7937 44.7352 16.6622 44.7352 16.6622 44.2622C16.6622 44.0268 16.4656 43.8352 16.2268 43.8352ZM16.2268 46.9602C14.7181 46.9602 13.4924 45.7497 13.4924 44.2622C13.4924 42.7747 14.7181 41.5664 16.2268 41.5664C17.7356 41.5664 18.9634 42.7747 18.9634 44.2622C18.9634 45.7497 17.7356 46.9602 16.2268 46.9602Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0658 43.1289C40.7019 43.1289 41.2175 43.6352 41.2175 44.2622C41.2175 44.8893 40.7019 45.3977 40.0658 45.3977C39.4277 45.3977 38.9142 44.8893 38.9142 44.2622C38.9142 43.6352 39.4277 43.1289 40.0658 43.1289Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_823_54324",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 43,
    width: 4,
    height: 3
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9147 44.2618C38.9147 44.8909 39.4282 45.3993 40.0663 45.3993C40.7003 45.3993 41.218 44.8909 41.218 44.2618C41.218 43.6347 40.7003 43.1284 40.0663 43.1284C39.4282 43.1284 38.9147 43.6347 38.9147 44.2618Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_823_54324)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3489 55.814H51.7837V32.7119H28.3489V55.814Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0638 43.8352C39.8271 43.8352 39.6327 44.0268 39.6327 44.2622C39.6348 44.7393 40.5012 44.7352 40.4991 44.2622C40.4991 44.0268 40.3025 43.8352 40.0638 43.8352ZM40.0638 46.9602C38.555 46.9602 37.3293 45.7497 37.3293 44.2622C37.3293 42.7747 38.555 41.5664 40.0638 41.5664C41.5747 41.5664 42.8024 42.7747 42.8024 44.2622C42.8024 45.7497 41.5747 46.9602 40.0638 46.9602Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderWhiteIcon);
export default __webpack_public_path__ + "static/media/order-white-icon.8f5b6a9e66009d7ac6cd41aaeaf41b5b.svg";
export { ForwardRef as ReactComponent };